import { UserOutlined, ArrowUpOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { Avatar, Flex, Typography, message, Tag } from "antd";
import { Colors, formatDateTime } from "../helpers";
import { useCallHistoryProvider } from "../context/CallHIstoryContext";
import { useTheme } from "../../../ThemeContext";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { DateSelectionPopup } from "./DateSelectionPopup";
import { Button } from "@voicecare.ai/ui-library";
import { rescheduleCall } from "../../../utils/apiClient";
import { convertUTCToLocalTime } from "../../../utils/helpers/date-time-utils";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const { Text } = Typography;

export const UserCard = ({
  avatarSrc,
  username,
  datetime,
  onClick,
  isActive,
  handlerType,
  i,
  callContent,
}) => {
  const { themeMode, currentTheme } = useTheme();
  function capitalizeFirstLetter(str) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  const startTimeRaw = callContent?.call_start_time;
  const endTimeRaw = callContent?.call_end_time;
  const startTime = startTimeRaw ? convertUTCToLocalTime(startTimeRaw) : null;
  const endTime = endTimeRaw ? convertUTCToLocalTime(endTimeRaw) : null;

  let callDuration = "pending";
  let callDate = "Scheduled";

  console.log("callContent", callContent?.call_status);

  if (startTime && endTime) {
    const duration = moment.duration(moment(endTime).diff(moment(startTime)));
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    callDuration = `${minutes}m ${seconds}s`;

    const startDate = moment(startTime);

    if (startDate.isSame(moment(), "day")) {
      callDate = `Today ${startDate.format("hh:mm A")}`;
    } else if (startDate.isSame(moment().subtract(1, "day"), "day")) {
      callDate = `Yesterday ${startDate.format("hh:mm A")}`;
    } else {
      callDate = `${startDate.format("MM/DD/YYYY : hh:mm A")}`;
    }
  } else if (startTime && !endTime) {
    callDate = "In Progress";
    callDuration = "Active";
  }

  if (callContent?.call_status === "cancelled") {
    callDate = "Cancelled";
    callDuration = "";
  }

  // Reattempt call functionality
  const [showDatePopup, setShowDatePopup] = useState(false);

  const handleReattemptCall = () => {
    setShowDatePopup(true);
  };

  const handleScheduleCall = async (requestBody) => {
    try {
      console.log("Scheduling call with:", requestBody);

      // Extract the required parameters from the request body
      const { callRequestId, utcStartTime } = requestBody;

      if (!callRequestId || !utcStartTime) {
        message.error("Missing required parameters for scheduling call");
        return;
      }

      // Call the API to reschedule the call
      const response = await rescheduleCall({
        callRequestId,
        startDateTime: utcStartTime,
      });

      if (response.statusCode === "SUCCESS") {
        message.success("Call reattempt scheduled successfully!");
        setShowDatePopup(false); // Close the popup on success
      } else {
        message.error(response.message || "Failed to schedule call reattempt");
      }
    } catch (error) {
      console.error("Error scheduling call:", error);
      message.error("Failed to schedule call reattempt. Please try again.");
    }
  };

  const handleCloseDatePopup = () => {
    setShowDatePopup(false);
  };

  return (
    <Flex
      direction="horizontal"
      size={16}
      className={`call-history__user-card ${isActive ? "active" : ""}`}
      style={{
        background: isActive
          ? currentTheme.callhistory.callListSelectedBackground
          : "transperant",
        color: currentTheme.callhistory.searchColor,
      }}
      justify="space-between"
      onClick={onClick}
    >
      <Flex justify="center" align="center" gap={10}>
        {/* <Avatar
          shape="square"
          size={40}
          style={{ border: "none" }}
          icon={
            themeMode === "light" ? (
              <img
                src="/icons/light-theme/user-icon-light.png"
                style={{
                  backgroundColor: isActive
                    ? currentTheme.callhistory.callListSelectedBackground
                    : currentTheme.callhistory.mainBackground,
                  // width: "5vh",
                  objectFit: "cover", // Ensures the image fits into the Avatar
                }}
                alt="Light Icon"
              />
            ) : (
              <img
                src="/icons/dark-theme/user-icon-dark.png"
                style={{
                  backgroundColor: isActive
                    ? currentTheme.callhistory.callListSelectedBackground
                    : currentTheme.callhistory.mainBackground,
                  // width: "5vh",
                  objectFit: "cover", // Ensures the image fits into the Avatar
                }}
                alt="Dark Icon"
              />
            )
          }
        /> */}
        <Flex vertical gap={1}>
          <Text
            ellipsis
            style={{
              color: currentTheme.callhistory.searchColor,
              fontWeight: "600",
            }}
          >
            {username}
          </Text>
          <Text
            style={{
              color: currentTheme.callhistory.searchColor,
              fontSize: 12,
            }}
            ellipsis
            type="secondary"
          >
            {" "}
            <ArrowUpOutlined
              style={{
                color: currentTheme.callhistory.searchColor,
                rotate: "45deg",
              }}
            />{" "}
            Call {capitalizeFirstLetter(handlerType || "status")}
          </Text>
        </Flex>
      </Flex>
      <Flex
        vertical
        gap={1}
        style={{ paddingRight: ".5rem" }}
        justify="center"
        align="end"
      >
        <Text
          style={{ color: currentTheme.callhistory.searchColor, fontSize: 14 }}
        >
          {callDate}
        </Text>
        <Text
          style={{ color: currentTheme.callhistory.searchColor, fontSize: 14 }}
          type="secondary"
        >
          {callDuration}
        </Text>
      </Flex>
    </Flex>
  );
};

export const UserInfoCard = ({ setRenderType }) => {
  const { getSelectedMemberInfo, setSelectedMember, callContent } =
    useCallHistoryProvider();
  const { member_name, member_id } = getSelectedMemberInfo() || {};
  const { themeMode, currentTheme } = useTheme();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();

  // Reattempt call functionality
  const [showDatePopup, setShowDatePopup] = useState(false);

  const handleReattemptCall = () => {
    setShowDatePopup(true);
  };

  const handleScheduleCall = async (requestBody) => {
    try {
      console.log("Scheduling call with:", requestBody);

      // Extract the required parameters from the request body
      const { callRequestId, utcStartTime } = requestBody;

      if (!callRequestId || !utcStartTime) {
        message.error("Missing required parameters for scheduling call");
        return;
      }

      // Call the API to reschedule the call
      const response = await rescheduleCall({
        callRequestId,
        startDateTime: utcStartTime,
      });

      if (response.statusCode === "SUCCESS") {
        message.success("Call reattempt scheduled successfully!");
        setShowDatePopup(false); // Close the popup on success
      } else {
        message.error(response.message || "Failed to schedule call reattempt");
      }
    } catch (error) {
      console.error("Error scheduling call:", error);
      message.error("Failed to schedule call reattempt. Please try again.");
    }
  };

  // Check if call has failed
  const isCallFailed = () => {
    const callOutcome = callContent?.call_outcome;
    return callOutcome === "Failed";
  };

  const handleCloseDatePopup = () => {
    setShowDatePopup(false);
  };

  return (
    <>
      <Flex
        direction="horizontal"
        size={16}
        className="call-history__user-card user-info"
        justify="space-between"
        style={{ paddingLeft: 0 }}
      >
        <Flex justify="center" align="center" gap={10}>
          <Tooltip title="Back to Call List">
            <IconButton
              aria-label="back"
              sx={{ color: "#ff4e3a", paddingBottom: 0 }}
              onClick={() => {
                // Navigate back to call list (remove callRequestId query parameter from URL)
                const currentBatchId = searchParams.get("batch_id");
                if (currentBatchId) {
                  navigate(`/call-history?batch_id=${currentBatchId}`);
                } else {
                  navigate(`/call-history`);
                }
                
                setRenderType("callList");
                setSelectedMember("");
              }}
            >
              <KeyboardBackspaceIcon sx={{ fontSize: 35 }} />
            </IconButton>
          </Tooltip>
          {/* <Avatar
            shape="square"
            size={70}
            style={{ border: "none" }}
            icon={
              themeMode === "light" ? (
                <img
                  src="/icons/light-theme/user-icon-light.png"
                  style={{
                    backgroundColor: currentTheme.callhistory.searchBackground,
                    // width: "8vh",
                    objectFit: "cover", // Ensures the image fits into the Avatar
                  }}
                  alt="Light Icon"
                />
              ) : (
                <img
                  src="/icons/dark-theme/user-icon-dark.png"
                  style={{
                    backgroundColor: currentTheme.callhistory.searchBackground,
                    width: "100%",
                    objectFit: "cover", // Ensures the image fits into the Avatar
                  }}
                  alt="Dark Icon"
                />
              )
            }
          /> */}

          <Flex vertical gap={1}>
            <Text
              ellipsis
              style={{
                color: currentTheme.callhistory.orange,
                fontWeight: "600",
                fontSize: 18,
              }}
            >
              {member_name}
            </Text>
            <Text
              style={{
                color: currentTheme.callhistory.textLight,
                fontSize: 16,
              }}
              ellipsis
              type="secondary"
            >
              Patient ID: {member_id}
            </Text>
          </Flex>
          {/* Failure Indicator Chip */}
          {isCallFailed() && (
            <Tag
              color="error"
              style={{
                marginBottom: "4px",
                fontSize: "10px",
                padding: "2px 6px",
                borderRadius: "4px",
                fontWeight: "bold",
              }}
            >
              FAILED
            </Tag>
          )}
        </Flex>

        {/* Reschedule Call Button */}
        <Flex align="center">
          <Button
            label="Reschedule This Call"
            onClick={handleReattemptCall}
            backgroundColor={currentTheme.loginPage.loginButtonColor}
            color="#ffffff"
            style={{
              border: `1px solid ${currentTheme.loginPage.loginButtonColor}`,
              borderRadius: "8px",
              padding: "12px 24px",
              fontSize: "16px",
              fontWeight: "bold",
              minWidth: "200px",
              height: "48px",
            }}
          />
        </Flex>
      </Flex>

      {/* Date Selection Popup */}
      <DateSelectionPopup
        visible={showDatePopup}
        onClose={handleCloseDatePopup}
        callRequestId={callContent?.call_request_id}
        onScheduleCall={handleScheduleCall}
      />
    </>
  );
};
